module.exports = __webpack_public_path__ + "img/school_hkjz.7002b15d.png";